import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Zap } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#0a0a0a] py-12 md:py-20 px-4" data-id="element-125">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-126">
        <div className="absolute top-[-10%] right-[-5%] w-[300px] md:w-[500px] h-[300px] md:h-[500px] bg-cyan-500/10 rounded-full blur-[80px] md:blur-[100px]" data-id="element-127" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[300px] md:w-[500px] h-[300px] md:h-[500px] bg-red-600/10 rounded-full blur-[80px] md:blur-[100px]" data-id="element-128" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-129">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center lg:text-left" data-id="element-130">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-red-500/30 bg-red-500/10 text-red-400 text-xs md:text-sm font-semibold tracking-wider mb-4 md:mb-6" data-id="element-131">
            <Zap size={14} data-id="element-132" />
            <span data-id="element-133">BIOHACKING ESENCIAL</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-4 md:mb-6" data-id="element-134">
            Recupera <span className="text-cyan-400" data-id="element-135">Energía</span>, Foco y
            Vitalidad en <span className="text-red-500" data-id="element-136">7 Días</span> Regulando
            tus Ritmos Naturales
          </h1>

          <p className="text-base md:text-xl text-gray-300 mb-6 md:mb-8 leading-relaxed max-w-xl mx-auto lg:mx-0" data-id="element-137">
            Un plan práctico para personas 35+ que sufren fatiga, niebla mental
            y bajones, basado en 4 palancas: luz, sueño, sistema nervioso y
            energía metabólica.
            <br data-id="element-138" />
            <span className="text-sm text-gray-500 mt-2 block" data-id="element-139">
              (Sin Suplementos Obligatorios)
            </span>
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-140">
            <CTAButton showPrice={false} data-id="element-141">Quiero Acceder Ahora</CTAButton>
          </div>
        </motion.div>

        {/* Image Content */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative flex justify-center" data-id="element-142">
          <div className="relative w-full max-w-[280px] md:max-w-md" data-id="element-143">
            {/* Glow behind book */}
            <div className="absolute inset-0 bg-cyan-500/20 blur-[40px] md:blur-[60px] rounded-full scale-90 animate-pulse" data-id="element-144" />

            <img src="https://cdn.magicpatterns.com/uploads/8E9wobJo46Jd3gvNc4BkAk/heylloyd-generated-1769625652820.png" alt="Longevidad Activa 35+ Libro" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl" data-id="element-145" />

            {/* Decorative circles - hidden on mobile */}
            <div className="absolute -top-10 -right-10 w-20 h-20 border border-red-500/30 rounded-full hidden md:block" data-id="element-146" />
            <div className="absolute -bottom-5 -left-5 w-32 h-32 border border-cyan-500/20 rounded-full hidden md:block" data-id="element-147" />
          </div>
        </motion.div>
      </div>
    </section>;
}